import React, { useState } from "react";
import "./header.scss";
import Logo from "../../Assets/logo/logo.PNG";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/free-solid-svg-icons";

import { Link, useHistory } from "react-router-dom";
import { useStateValue } from "../StateProvider";
import { auth } from "../../Config/Config";
import { categories } from "./Categories";
import productCards from "./../../Data";

import ProductCards from "../ProductCards";

const Header = () => {
  const history = useHistory();
  const [{ basket, user }, dispatch] = useStateValue();
  const [search, setSearch] = useState("");

  const logOutuser = () => {
    if (user) {
      auth.signOut();
      history.push("/");
    }
  };

  const [category, setCategory] = useState(false);
  const [down, setdown] = useState(false);
  const [toggleHamburger, setToggleHamburger] = useState(false);

  function handleClick() {
    setCategory(!category);
    setdown(!down);
  }

  function handleHamburger() {
    setToggleHamburger(!toggleHamburger);
  }

  const categoryEvent = (event) => {
    const targetValue = event.target.textContent;
    history.push("/category/" + targetValue);
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg sticky-top">
        <div className="container ">
          <div className="brand">
            <Link className="navbar-brand" to="/">
              <img src={Logo} alt="logo" />
            </Link>
          </div>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
            onClick={handleHamburger}
          >
            {toggleHamburger ? (
              <i
                className="fas fa-times"
                style={{ transition: " all 0.3s ease-in" }}
              ></i>
            ) : (
              <i
                className="fas fa-hamburger"
                style={{ transition: " all 0.3s ease-in" }}
              ></i>
            )}
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav ml-auto mr-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Link className="nav-link active" aria-current="page" to="/">
                  <FontAwesomeIcon
                    icon={faHome}
                    style={{ marginRight: "5px" }}
                  />
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/about">
                  About
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link" to="/blogs">
                  Blogs
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link" to="/contact">
                  Contact us
                </Link>
              </li>
            </ul>

            <ul className="navbar-nav">
              <li className="nav-item">
                <Link to={!user && "/login"} className="nav-link">
                  <div className="user" onClick={logOutuser}>
                    <span className="span1">
                      Hello {!user ? "Guest" : user.email}
                    </span>
                    <span className="span2">
                      {user ? "Sign Out" : "Sign In"}
                    </span>
                  </div>
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link" to="/orders">
                  <div className="user">
                    <span className="span1">Your</span>
                    <span className="span2">Orders</span>
                  </div>
                </Link>
              </li>

              <li className="nav-item">
                <Link to="/checkout" className="nav-link">
                  <i
                    class="fas fa-shopping-bag"
                    style={{ position: "relative" }}
                  >
                    <span
                      class="badge bg-success"
                      style={{
                        position: "absolute",
                        top: "-5px",
                        left: "10px",
                        fontSize: "10px",
                        color: "#fff",
                      }}
                    >
                      {basket?.length}
                    </span>
                  </i>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      <header className="header">
        <div className="container">
          <div className="header-top">
            <div className="categories" onClick={handleClick}>
              <i class="fas fa-list"></i>
              <span>CATEGORIES</span>

              {down ? (
                <i
                  className="fas fa-angle-up"
                  style={{
                    transition: "all 0.4s ease-in-out",
                    marginLeft: "3rem",
                  }}
                ></i>
              ) : (
                <i
                  className="fas fa-angle-down"
                  style={{
                    transition: "all 0.4s ease-in-out",
                    marginLeft: "3rem",
                  }}
                ></i>
              )}
              {category ? (
                <div className="categoryNames">
                  {categories.map((category) => (
                    <div
                      style={{
                        borderBottom: "0.1rem solid #150E56",
                        paddingTop: "20px",
                        paddingBottom: "20px",
                      }}
                    >
                      <Link className="category-link" onClick={categoryEvent}>
                        <i
                          className={category.icon}
                          style={{ color: "#150e56" }}
                        ></i>
                        {category.name}
                      </Link>
                    </div>
                  ))}
                </div>
              ) : null}
            </div>

            <div className="search">
              <input
                className="input-box"
                type="text"
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
                autofocus="on"
                placeholder="Search products here........"
              />
              <i class="fas fa-search"></i>
            </div>
          </div>
        </div>
      </header>

      <div className="container">
        <div className="d-flex" style={{ flexWrap: "wrap" }}>
          {productCards
            .filter((item) => {
              if (search === "") {
                return null;
              } else if (
                item.title.toLowerCase().includes(search.toLowerCase())
              ) {
                history.push("/SearchProducts");
                return item;
              }
            })
            .map((item) => (
              <div
                style={{
                  width: "250px",
                  marginRight: "20px",
                  marginTop: "20px",
                }}
              >
                <ProductCards
                  id={item.id}
                  title={item.title}
                  image={item.img}
                  rating={item.rating}
                  price={item.price}
                />
              </div>
            ))}
        </div>
      </div>
    </>
  );
};

export default Header;
